module.exports = __webpack_public_path__ + "img/icon-53.72bfbc43.svg";